import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { scrollToId } from "../lib/scroll";

export const MobileCTA = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const target = document.getElementById("inquire");
    if (!target) return;
    const obs = new IntersectionObserver(([entry]) => setHidden(entry.isIntersecting), {
      threshold: 0.08,
    });
    obs.observe(target);
    return () => obs.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.div
          data-testid="mobile-persistent-enquire-cta"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: 1.6 }}
          className="fixed bottom-4 inset-x-4 z-40 md:hidden"
        >
          <button
            onClick={() => scrollToId("inquire")}
            className="w-full text-[11px] uppercase tracking-[0.28em] bg-[#C9A25F] text-[#2A1F16] py-4 rounded-full shadow-[0_16px_40px_-12px_rgba(42,31,22,0.35)] border border-[#B8893B]/30"
          >
            Enquire Now
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
